import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { useNavigate, useParams } from "react-router-dom";

import "./Header.scss";
import { setMenuList, setSelectedMenu } from "../../module/menu/menu.action";
import { setAuthInfo } from "../../module/auth/auth.action";

import logo from "../../assets/images/logo.svg";
import profileImage from "../../assets/images/profile-default.svg";
import { CONFIG } from "../../config/constant";
import { translation } from '../../i18';

const Header = React.memo((props) => {
  const { searchContent, searchClose } = props;
  const { t } = translation();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const params = useParams();
  const [openSearch, setOpenSearch] = useState(false);
  const [query, setQuery] = useState('');

  const homeCategory = { category_name: 'Home', _id: "home" };
  const { token, avatar } = useSelector((state) => state.auth);
  const { language } = useSelector((state) => state.config);
  const menu = useSelector((state) => state.menu);
  useEffect(() => {
    if (!menu?.list?.length) {
      menuList();
    }
  }, []);

  useEffect(() => {
    if (menu?.list?.length && !menu.selectedMenu) {
      dispatch(setSelectedMenu(homeCategory));
    }
  }, [menu?.list]);


  async function menuList() {
    const url = CONFIG.BASE_URL + "app/category";
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      dispatch(setMenuList(response));
    } else {
      response = await response.json();
    }
  }


  const clickHandler = (e, item) => {
    e.preventDefault();
    e.stopPropagation();

    switch (item) {
      case 'signup':
        navigate(`/signup`);
        break;
      case 'search':
        dispatch(setSelectedMenu(item));
        setOpenSearch(true)
        // dispatch(setSelectedMenu('search'));
        // navigate(`/search`);
        break;
      case 'close':
        if (openSearch) {
          dispatch(setSelectedMenu(homeCategory));
          searchContent('');
        }
        setOpenSearch(false);
        setQuery('');
        searchClose();

        // dispatch(setSelectedMenu('search'));
        // navigate(`/search`);
        break;
      default:
        navigate(`/category/${item?._id}`);
        break;
    }
  }

  const logout = (e) => {
    cookies.remove("email");
    cookies.remove("token");
    cookies.remove("role");
    cookies.remove("userid");
    cookies.remove("isLogin");
    dispatch(setAuthInfo({
      email: "",
      token: "",
      role: "",
      userid: "",
      isLogin: false,
    }));
    navigate("/login");
  }

  const settingMenuHandler = (e, item) => {
    switch (item) {
      case 'profile':
        dispatch(setSelectedMenu('profile'));
        navigate(`/profile`);
        break;
      case 'language':
        dispatch(setSelectedMenu('language'));
        navigate(`/language`);
        break;
      case 'logout':
        logout(e);
        break;
    }
  }

  const keyDownHandler = (e) => {
    const key = e.keyCode;
    switch (key) {
      case 13:
        searchContent(query);
        break;
    }
  }

  return (
    <div className="header-container">
      <div className="left-section">
        <ul className="menu">
          <li className={`menu-item ${menu?.selectedMenu?._id == homeCategory._id ? 'active' : ''}`} tabIndex={0} key="home" onClick={(event) => clickHandler(event, homeCategory)}>{t(homeCategory?._id)}</li>
          {menu?.list?.map((item) => {
            return (<li className={`menu-item ${menu?.selectedMenu?._id == item?._id ? 'active' : ''}`} tabIndex={0} key={item?._id} onClick={(event) => clickHandler(event, item)}>{item?.category_name}</li>)
          })}
        </ul>
      </div>
      <div className="center-section">
        <img src={logo} />
      </div>
      <div className="right-section">

        {openSearch ? (<div className="search-input-wrapper">
          <input type="text" className="search-text" placeholder="Search content" value={query} onChange={(e) => { setQuery(e.target.value) }} onKeyDown={keyDownHandler} />
          <span className="search-icon" onClick={(event) => clickHandler(event, 'close')}></span>
        </div>) : <span className="search" onClick={(event) => clickHandler(event, 'search')}></span>}
        {token ? <span className="profile-icon-wrapper">
          <img className="profile-icon" src={avatar || profileImage} />
          <ul className="profile-menu">
            <li className="profile-menu-item" onClick={(event) => settingMenuHandler(event, 'profile')}>{t('profile')}</li>
            <li className="profile-menu-item" onClick={(event) => settingMenuHandler(event, 'language')}>{t('language')}</li>
            <li className="profile-menu-item" onClick={(event) => settingMenuHandler(event, 'logout')}>{t('logout')}</li>
          </ul>
        </span> : <span className="signup-button" onClick={(event) => clickHandler(event, 'signup')}>signup</span>}
      </div>
    </div>
  );
});

const mapStateToProps = (state) => ({
  auth: state.auth,
  menu: state.menu,
});

export default Header;
